// Types
import type {
    I_apiGetDeps_Brands,
    I_apiGetDeps_Categories,
} from "@/hooks/requests/apiGetDeps/apiGetDeps.types";
import type {
    I_apiGetModels_Data,
    I_apiGetModels_Data_Arr,
} from "@/hooks/requests/apiGetModels/apiGetModels.types.";
import type {
    I_apiGetProducts_Data,
    I_apiGetProducts_Data_Arr,
} from "@/hooks/requests/apiGetProducts/apiGetProducts.types";

export const hierarchy = [
    "field_brand",
    "field_category",
    "field_model",
    "field_storage",
    "field_color",
    "field_CPU",
    "field_GPU",
    "field_RAM",
    "field_Memory",
] as const;

export interface I_Field<T> {
    value: T | null;
    data: T[];
}

export type FieldName = (typeof hierarchy)[number];

export type I_field_brand = I_Field<I_apiGetDeps_Brands>;

export type I_field_category = I_Field<I_apiGetDeps_Categories>;

export type I_field_model = I_Field<I_apiGetModels_Data>;

export type I_field_other = I_Field<I_apiGetProducts_Data>;

export type Fields = I_Field<
    | I_apiGetDeps_Brands
    | I_apiGetDeps_Categories
    | I_apiGetModels_Data_Arr[number]
    | I_apiGetProducts_Data_Arr[number]
>;

export type FieldsMap = Record<FieldName, Fields>;
export interface I_DefaultCategoryValue {
    brandName: string;
    categoryName: string;
}
